import React from 'react';
import { useSearchParams } from 'react-router-dom';

const AuthErrorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const errorType = searchParams.get('type') || 'unknown';

  // エラー種別ごとのメッセージ設定
  const errorMessages: Record<string, { title: string; message: string }> = {
    user_type: {
      title: 'アクセス権限がありません',
      message: '「SONAE-AI」は東京商工会議所の会員限定サービスです。ご利用条件を満たしていない可能性があります。',
    },
    invalid_session: {
      title: 'セッションが無効です',
      message: 'ログインセッションの有効期限が切れました。お手数ですが、画面を閉じて再度ログインしてください。',
    },
    api_down: {
      title: '認証サービスエラー',
      message: '認証サービスとの通信に失敗しました。時間をおいてから再度お試しいただくか、問題が解決しない場合はお問い合わせください。',
    },
    unknown: {
      title: '認証エラー',
      message: '画面を一度閉じて再度お試しください。',
    },
  };

  const error = errorMessages[errorType] || errorMessages.unknown;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* 認証エラーアイコン */}
          <div className="mx-auto flex items-center justify-center h-24 w-24 bg-red-100 rounded-full mb-6">
            <svg className="h-12 w-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 0h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>

          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            {error.title}
          </h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            {error.message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorPage;
